import { errorReporter } from 'fitify-ui/src/utils/error-reporter'

declare global {
  interface Window {
    __reportMissingTranslation?: (entry: {
      namespace: string
      key: string
      locale: string
    }) => void
  }
}

class MissingTranslationError extends Error {
  readonly namespace: string
  readonly key: string
  readonly locale: string

  constructor({
    namespace,
    key,
    locale,
  }: {
    namespace: string
    key: string
    locale: string
  }) {
    super(
      `[i18n] Missing translation "${key}" (namespace: ${namespace}, locale: ${locale})`
    )
    this.name = 'MissingTranslationError'
    this.namespace = namespace
    this.key = key
    this.locale = locale
  }
}

const reported = new Set<string>()

export const handleMissingTranslation = (
  lngs: readonly string[],
  namespace: string,
  key: string
) => {
  const locale = lngs[0] ?? 'unknown'
  const id = `${locale}:${namespace}:${key}`

  if (reported.has(id)) {
    return
  }
  reported.add(id)

  const error = new MissingTranslationError({ namespace, key, locale })

  if (typeof window === 'undefined') {
    console.error(error)
    return
  }

  if (window.__reportMissingTranslation) {
    window.__reportMissingTranslation({ namespace, key, locale })
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error(error)
    return
  }

  void errorReporter.report(error)
}
